import * as React from 'react';
const ApneaNotturnaIcon = ({ primaryColor, secondaryColor, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="prefix__Livello_2"
    data-name="Livello 2"
    viewBox="0 0 200 200"
    style={{ width }}
  >
    <defs>
      <style>{`.prefix__cls-1{fill:${secondaryColor ||
        '#ffcf37'}}.prefix__cls-2{fill:none;stroke:${primaryColor ||
        '#282828'};stroke-linecap:round;stroke-linejoin:round;stroke-width:3.89px}`}</style>
    </defs>
    <path
      d="M67.57 94.6c-4.47 5.89-8.01 13.15-8.76 19.97-3.05.94-5.06 3.53-4.65 6.25.47 3.1 3.91 5.19 7.68 4.67q0 0 0 0c11.39 12.84 30.39 18.87 43.07 18.66.04.14.05.27.1.4 1.2 3.62 4.71 5.81 7.85 4.89 2.87-.85 4.4-4.02 3.71-7.33 10.46-5.37 25.49-21.38 25.85-37.25.19-.14.39-.25.58-.41 3.03-2.53 3.81-6.51 1.75-8.9-1.96-2.27-5.77-2.25-8.74-.09-13.62-11.52-27.75-14.24-38.87-14.61"
      className="prefix__cls-2"
    />
    <path
      d="M128.15 102.23c-5.91 3.45-16.99 14.63-21.47 25.65"
      className="prefix__cls-2"
    />
    <path
      d="M81.8 64.76v-2.53c0-.49-.4-.89-.89-.89h-4.75l5.39-7.82c.1-.15.16-.33.16-.51v-1.76c0-.49-.4-.89-.89-.89h-9.81c-.49 0-.89.4-.89.89v2.53c0 .49.4.89.89.89h4.2l-5.52 7.94c-.1.15-.16.33-.16.51v1.64c0 .49.4.89.89.89h10.49c.49 0 .89-.4.89-.89M97.41 63.5l-7.5-3.25a.745.745 0 0 0-.98.39l-.84 1.93c-.16.38 0 .82.39.98l3.21 1.39-6.85 4.25a.74.74 0 0 0-.29.34l-.54 1.26c-.16.38.01.82.39.98l8.02 3.47c.38.16.82 0 .98-.39l.84-1.93a.745.745 0 0 0-.39-.98l-3.63-1.57 6.71-4.2c.13-.08.23-.2.29-.34l.58-1.35a.745.745 0 0 0-.39-.98M82.05 80.27l-.69-1.7a.65.65 0 0 0-.84-.36l-3.2 1.29 1.5-6.73c.03-.13.02-.26-.03-.38l-.48-1.19a.65.65 0 0 0-.84-.36l-6.6 2.66a.65.65 0 0 0-.36.84l.69 1.7c.13.33.51.49.84.36l2.83-1.14-1.55 6.84q-.045.195.03.39l.45 1.11c.13.33.51.49.84.36l7.06-2.85a.65.65 0 0 0 .36-.84Z"
      className="prefix__cls-1"
    />
    <circle cx={80.97} cy={88.01} r={2.9} className="prefix__cls-1" />
    <circle cx={83.18} cy={94.97} r={2.22} className="prefix__cls-1" />
    <path
      d="M80.97 98.86c-.93 0-1.69.76-1.69 1.69s.76 1.69 1.69 1.69 1.69-.76 1.69-1.69-.76-1.69-1.69-1.69"
      className="prefix__cls-1"
    />
  </svg>
);
export default ApneaNotturnaIcon;
